var map = {
	"./agentega.png": "kAQa",
	"./ambulatilis.jpg": "Fpv1",
	"./anota.png": "Ytv/",
	"./campusparty.png": "m9Ag",
	"./cgpdt.png": "S4+3",
	"./cliptopia.png": "6k2E",
	"./comissaoarns.png": "GYBB",
	"./copar.png": "NI90",
	"./cryptoqubes.png": "m12J",
	"./cuidando.jpg": "toZh",
	"./digitalrights.png": "okar",
	"./direitossilencios.png": "r/w/",
	"./dl.png": "sYkL",
	"./ethermap.jpg": "U6z6",
	"./etherplant.png": "bV1w",
	"./isofia.jpg": "eAlC",
	"./labmacambira.png": "C1qZ",
	"./labyrimental.jpg": "d8g6",
	"./leggo.png": "OYt6",
	"./mapinguari.png": "OoYB",
	"./monitorando.jpg": "WMRQ",
	"./odd.svg": "lt/i",
	"./radar.png": "x4QP",
	"./samia.jpg": "VQwO",
	"./secom.png": "Xbm3",
	"./seminariocamara.svg": "uZ/m",
	"./trazdia.png": "iBtO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ueru";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/full/projects ^\.\/.*$
// module id = ueru
// module chunks = 0